import { useState } from 'react';
import {
  getTopProducts,
  getLowProducts,
  getFastestGrowingProducts,
  getDecliningProducts,
  getStreakWeekProducts, getHourlyPerformance, getFilterOption
} from '../../../../services/productGrowth';

const useProductGrowth = () => {
  const [top10, setTop10] = useState([]);
  const [low10, setLow10] = useState([]);
  const [fastestGrowing, setFastestGrowing] = useState([]);
  const [declining, setDeclining] = useState([]);
  const [heroes, setHeroes] = useState([]);
  const [hourlyPerformanceState, setHourlyPerformanceState] = useState([]);
  const [filterOptions, setFilterOptions] = useState(null);
  const [accessDenied, setAccessDenied] = useState(false);
  const [loading, setLoading] = useState({
    top10: false,
    low10: false,
    fastestGrowing: false,
    declining: false,
    heroes: false,
    hourlyPerformance: false,
    filterOptions: false,
  });

  const fetchTop10 = async (params) => {
    setLoading(prev => ({ ...prev, top10: true }));
    try {
      const response = await getTopProducts(params);
      setTop10(response);
    } catch (error) {
      console.error("Error fetching top 10 products:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoading(prev => ({ ...prev, top10: false }));
    }
  };

  const fetchLow10 = async (params) => {
    setLoading(prev => ({ ...prev, low10: true }));
    try {
      const response = await getLowProducts(params);
      setLow10(response);
    } catch (error) {
      console.error("Error fetching low 10 products:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoading(prev => ({ ...prev, low10: false }));
    }
  };

  const fetchFastestGrowing = async (params) => {
    setLoading(prev => ({ ...prev, fastestGrowing: true }));
    try {
      const response = await getFastestGrowingProducts(params);
      setFastestGrowing(response);
    } catch (error) {
      console.error("Error fetching fastest growing products:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoading(prev => ({ ...prev, fastestGrowing: false }));
    }
  };

  const fetchDeclining = async (params) => {
    setLoading(prev => ({ ...prev, declining: true }));
    try {
      const response = await getDecliningProducts(params);
      setDeclining(response);
    } catch (error) {
      console.error("Error fetching declining products:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoading(prev => ({ ...prev, declining: false }));
    }
  };

  const fetchHeroes = async (params) => {
    setLoading(prev => ({ ...prev, heroes: true }));
    try {
      const response = await getStreakWeekProducts(params);
      setHeroes(response);
    } catch (error) {
      console.error("Error fetching heroes products:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoading(prev => ({ ...prev, heroes: false }));
    }
  };

  const fetchHourlyPerformance = async (params) => {
    setLoading(prev => ({ ...prev, hourlyPerformance: true }));
    try {
      const response = await getHourlyPerformance(params);
      setHourlyPerformanceState(response);
    } catch (error) {
      console.error("Error fetching hourlyPerformance products:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoading(prev => ({ ...prev, hourlyPerformance: false }));
    }
  };

  const fetchFilterOption = async (params) => {
    setLoading(prev => ({ ...prev, filterOptions: true }));
    try {
      const response = await getFilterOption(params);
      setFilterOptions(response.data);
    } catch (error) {
      console.error("Error fetching filter options:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoading(prev => ({ ...prev, filterOptions: false }));
    }
  };

  return {
    top10,
    low10,
    fastestGrowing,
    declining,
    heroes,
    hourlyPerformanceState,
    filterOptions,
    loading,
    fetchTop10,
    fetchLow10,
    fetchFastestGrowing,
    fetchDeclining,
    fetchHeroes,
    fetchHourlyPerformance, fetchFilterOption, accessDenied

  };
};

export default useProductGrowth;
